import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgEnvelopePresentationIcon = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Envelope on an easel",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <g clipPath="url(#clip0_1021_328)">
      <path
        d="M16.875 3.75H3.125C2.77982 3.75 2.5 4.02982 2.5 4.375V13.75C2.5 14.0952 2.77982 14.375 3.125 14.375H16.875C17.2202 14.375 17.5 14.0952 17.5 13.75V4.375C17.5 4.02982 17.2202 3.75 16.875 3.75Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 14.375L15 17.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.375L5 17.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.75V1.875"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10L3 4"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10L17 4"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00002 14L8.50018 9.00003"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4997 14L11.9995 8.99997"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1021_328">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

const EnvelopePresentation = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgEnvelopePresentationIcon />
  </BaseIcon>
);

export default EnvelopePresentation;
